<template>
    <div class="level-item__list">
        <!-- selected language rules -->
        <template v-if="rules && rules.length">
            <router-link
                v-for="rule in rules"
                :key="rule.contentId"
                :to="{name: 'rules-inner', params: { rule: rule.alias || rule.name }}"
                class="basement-link bng-clickable bng-underlined"
            >
                <string-content :content-ref="rule" field="title" />
            </router-link>
        </template>

        <!-- english rules -->
        <template v-if="lang != 'en' && enRules && enRules.length">
            <router-link
                v-for="rule in enRules"
                :key="rule.contentId"
                :to="{name: 'rules-inner', params: { rule: rule.name }}"
                class="basement-link bng-clickable bng-underlined"
            >
                <string-content :content-ref="rule" field="title" />
                <span class="has-text-weight-bold"> (EN)</span>
            </router-link>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';

import StringContent from '../../../../../_common/components/content/string-content.js';
import content from '../../../../../_common/data/content.js';

export default {
    name: 'basement-rules',
    components: { StringContent },
    data() {
        return {
            rules: null,
            enRules: null
        };
    },
    computed: {
        lang() {
            return Vue.state.lang.currentLang;
        },
        strings() {
            return Vue.state.content.strings.get();
        }
    },
    watch: {
        lang() {
            this.reloadRules();
        }
    },
    async created() {
        await Vue.state.client.ensure();
        this.reloadRules();
    },
    methods: {
        reloadRules() {
            const contents = Vue.state.client.get().view.legal.allRules.map(rule => {
                const str = this.strings.find(str => str.id === rule.contentId);
                return Object.assign({}, rule, str)
            });
            this.rules = contents.filter(c => c.language === this.lang);
            this.enRules = contents.filter(c => c.language === "en" && !this.rules.find(r => r.alias === c.alias));
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/basement/rules.vue